import { observer, inject } from 'mobx-react'
import { FieldContainer, Title, BulletText } from '../styled'

const AdditionalSavings = props => {
  // `acceptedCase` is a declared maybeNull: without a case there is nothing to
  // compare the base case against, so render no block at all.
  if (props.store.acceptedCase == null) return null

  const { displayName } = props.store.person
  const { special457, special403b, employerAccount, baseCase } = props.store
  // `baseCase` is a declared maybeNull, and the two contribution bullets below are
  // base-vs-accepted comparisons -- with no base case there is nothing to compare, so
  // they stay hidden rather than counting a missing base value as a change. The
  // out-of-plan savings bullets read off the accepted case and still stand.
  const {
    client457PreTaxSaving: base457pretax,
    client457RothSaving: base457roth,
    client403bPreTaxSaving: base403bpretax,
  } = baseCase ?? {}
  const {
    outOfPlanMonthlySavings,
    client457PreTaxSaving: case457pretax,
    client457RothSaving: case457roth,
    client403bPreTaxSaving: case403bpretax,
  } = props.store.acceptedCase

  return (
    <FieldContainer>
      <Title>Savings in addition to retirement & other accounts</Title>
      {baseCase != null &&
        employerAccount[0]?.planType !== 4 &&
        special457 &&
        (base457pretax !== case457pretax || base457roth !== case457roth) && (
          <BulletText>
            Update contribution to {displayName}
            's 457 account
          </BulletText>
        )}
      {baseCase != null &&
        employerAccount[0]?.planType !== 2 &&
        special403b &&
        base403bpretax !== case403bpretax && (
          <BulletText>
            Update contribution to {displayName}
            's 403(b) account
          </BulletText>
        )}
      {outOfPlanMonthlySavings > 0 && (
        <>
          <BulletText>
            Decide whether to save more in an existing account or to open a new account
          </BulletText>
          <BulletText>Make your first deposit</BulletText>
          <BulletText>
            Set up automatic ongoing deposits, if available, or reminders as needed
          </BulletText>
        </>
      )}
    </FieldContainer>
  )
}

export default inject('store')(observer(AdditionalSavings))
